import { useEffect, useRef, type ReactNode } from 'react';

export type PickerMenuAlign = 'left' | 'right';

interface PickerMenuShellProps {
    heading?: string;
    children: ReactNode;
}

const SHELL_CLASS =
    'w-[248px] bg-white border border-gray-200 rounded-[10px] shadow-[0_10px_28px_rgba(0,0,0,0.13)]';

const SELECTED_OPTION_SELECTOR = '[aria-current="true"]';
export const PICKER_MENU_SELECTOR = '[data-picker-menu]';

export function PickerMenuShell({ heading, children }: PickerMenuShellProps) {
    const shellRef = useRef<HTMLDivElement>(null);
    // Portaled to the end of <body>, so Tab from the trigger never reaches it: start focus inside.
    useEffect(() => {
        const shell = shellRef.current;
        if (!shell || shell.contains(document.activeElement)) return;
        const target =
            shell.querySelector<HTMLElement>(SELECTED_OPTION_SELECTOR) ??
            shell.querySelector<HTMLElement>('button');
        target?.focus({ preventScroll: true });
    }, []);
    return (
        <div
            ref={shellRef}
            data-picker-menu
            className={SHELL_CLASS}
            onClick={(e) => e.stopPropagation()}
        >
            {heading && (
                <div className="px-3 pt-2 pb-1">
                    <span className="text-[10.5px] font-semibold tracking-wide text-gray-400 uppercase">
                        {heading}
                    </span>
                </div>
            )}
            {children}
        </div>
    );
}

export function PickerMenuDivider() {
    return <div className="border-t border-gray-100 my-0.5" />;
}
